import { API } from '../config/config';

const OfferService = {
  getAll: () => getOffers(),
  getById: (id) => getOffer(id),
  create: (data) => createOffer(data),
  update: (id, data) => updateOffer(id, data),
  delete: (id) => deleteOffer(id),
  toggleActive: (id, data) => toggleOfferActive(id, data),
  getUsageReport: (id) => getOfferUsageReport(id),
  getStats: (id) => getOfferStats(id),
  getAllStats: () => getAllOffersStats(),
};

const getOffers = async () => {
  try {
    const response = await API.get('/offers');
    return response.data;
  } catch (err) {
    console.error('Error fetching offers:', err);
    throw new Error(err);
  }
};

const getOffer = async (id) => {
  try {
    const response = await API.get(`/offers/${id}`);
    return response.data;
  } catch (err) {
    console.error('Error fetching offer:', err);
    throw new Error(err);
  }
};

const createOffer = async (data) => {
  try {
    // Limpiar campos que no deben enviarse al backend
    const cleanData = { ...data };
    delete cleanData._id;
    delete cleanData.id;
    delete cleanData.created_at;
    delete cleanData.updated_at;
    delete cleanData.created_by;
    delete cleanData.updated_by;
    
    const response = await API.post('/offers', cleanData);
    return response.data;
  } catch (err) {
    console.error('Error creating offer:', err);
    console.error('Data sent:', data);
    if (err.response) {
      console.error('Response error:', err.response.data);
    }
    throw err;
  }
};

const updateOffer = async (id, data) => {
  try {
    // Limpiar campos que no deben enviarse al backend
    const cleanData = { ...data };
    delete cleanData._id;
    delete cleanData.id;
    delete cleanData.created_at;
    delete cleanData.updated_at;
    delete cleanData.created_by;
    delete cleanData.updated_by;
    
    const response = await API.put(`/offers/${id}`, cleanData);
    return response.data;
  } catch (err) {
    console.error('Error updating offer:', err);
    console.error('Data sent:', data);
    if (err.response) {
      console.error('Response error:', err.response.data);
    }
    throw err;
  }
};

const deleteOffer = async (id) => {
  try {
    const response = await API.delete(`/offers/${id}`);
    return response.data;
  } catch (err) {
    console.error('Error deleting offer:', err);
    throw new Error(err);
  }
};

const toggleOfferActive = async (id, data) => {
  try {
    const response = await API.patch(`/offers/${id}/toggle`, data);
    return response.data;
  } catch (err) {
    console.error('Error toggling offer active:', err);
    throw new Error(err);
  }
};

const getOfferUsageReport = async (id) => {
  try {
    const response = await API.get(`/offers/${id}/usage`);
    return response.data;
  } catch (err) {
    console.error('Error fetching offer usage report:', err);
    throw new Error(err);
  }
};

const getOfferStats = async (id) => {
  try {
    const response = await API.get(`/offers/${id}/stats`);
    return response.data;
  } catch (err) {
    console.error('Error fetching offer stats:', err);
    throw new Error(err);
  }
};

const getAllOffersStats = async () => {
  try {
    const response = await API.get('/offers/stats/all');
    return response.data;
  } catch (err) {
    console.error('Error fetching all offers stats:', err);
    throw new Error(err);
  }
};

export default OfferService;
